import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

export const deleteCasesMutation = {
  mutationFn: (data: { caseIds: number[] }) =>
    w.json({ caseIds: data.caseIds }).delete(API_ENDPOINTS.business.v2.case.index).json(),
}
